import React from 'react'

export const FilePart = () => {
  return (
    <div>FilePart</div>
  )
}

export default FilePart
